import { render, staticRenderFns } from "./TextContentCreation.vue?vue&type=template&id=fbc63f68"
import script from "./TextContentCreation.vue?vue&type=script&lang=js"
export * from "./TextContentCreation.vue?vue&type=script&lang=js"
import style0 from "./TextContentCreation.vue?vue&type=style&index=0&id=fbc63f68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports